export var GET_NETWORK_INIT = 'GET_NETWORK_INIT';
export var GET_NETWORK_SUCCESS = 'GET_NETWORK_SUCCESS';
export var GET_NETWORK_ERROR = 'GET_NETWORK_ERROR';
export var GET_NETWORK_DONE = 'GET_NETWORK_DONE';
export var GET_LINE_ITEM_INIT = 'GET_LINE_ITEM_INIT';
export var GET_LINE_ITEM_SUCCESS = 'GET_LINE_ITEM_SUCCESS';
export var GET_LINE_ITEM_ERROR = 'GET_LINE_ITEM_ERROR';
export var GET_LINE_ITEM_DONE = 'GET_LINE_ITEM_DONE';
